import { db } from "../lib/api";
import { useQuery } from "../lib/hooks";
import { fmtShort } from "./ui";

/** "3 referrals so far · 1 since last review" (people linked as Referred by this client) */
export function ReferralLine({ personId, long }: { personId: string; long?: boolean }) {
  const q = useQuery(`person:${personId}:referrals`, () => db.rpc<{ total: number; since_review: number; last_review: string | null; asked: number; asked_since_review: number; last_asked: string | null }>("referral_counts", { p_person: personId }));
  const r = q.data;
  if (!r) return null;
  const since = r.last_review ? `${r.since_review} since last review (${fmtShort(r.last_review)})` : "no review yet";
  return long
    ? <>{r.total} referral{r.total === 1 ? "" : "s"} from them so far · {since}. Asked {r.asked} time{r.asked === 1 ? "" : "s"}{r.last_review ? ` (${r.asked_since_review} since last review)` : ""}{r.last_asked ? `, last ${fmtShort(r.last_asked)}` : ""}.</>
    : <>{r.total} referral{r.total === 1 ? "" : "s"} so far · {r.since_review} since last review</>;
}
